import React, { useState } from "react";
import classes from "../Homescreen/Homescreen.module.css";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase-config";

function LoginPage() {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const login = async () => {
    try {
      await signInWithEmailAndPassword(auth, loginEmail, loginPassword);
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div className={classes.login}>
      <div className={classes.login_screen}>
        <div className={classes.loginLogo}>
          <img
            style={{ height: "50px", width: "50px"}}
            alt=""
            src={require("../utils/img/LAmini.png")}
          />
        </div>
        <h2>LOGIN</h2>
        <div className={classes.inputBox}>
          <input
            placeholder="email"
            onChange={(e) => {
              setLoginEmail(e.target.value);
            }}
          />
        </div>
        <div className={classes.inputBox}>
          <input
            placeholder="password"
            onChange={(e) => {
              setLoginPassword(e.target.value);
            }}
          />
        </div>
        <div className={classes.inputBox}>
          <button onClick={login}>Login</button>
        </div>

        {/* <Link to="/home">return to DASHBOARD</Link> */}
      </div>
    </div>
  );
}

export default LoginPage;
